import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { getObjProperty } from "@utilities/mrVueUtils";

export default {

  data() {
    return {
      addingToBag: false
    };
  },

  computed: {
    ...mapState('cms', ['cmsSettings']),
    ...mapState('pdp', [
      'product',
      'purchaseType',
      'qty',
      'subFrequency',
      'skipPurchasePanel',
      'extraTube',
      'addPerfectPair',
      'attachableProdIds'
    ]),

    ...mapState('refillCart', ['modifyingRefillProduct']),

    ...mapGetters('refillCart', ['baseSubscription']),
    ...mapGetters('cart', ['productMaxQtyInCart']),

    hasMembershipBenefits() {
      return Boolean((getObjProperty(this, 'product.membershipBenefits') || []).length);
    },

    itemsToAdd() {
      var items = [
        {
          product_id: this.product.id,
          subscription: this.purchaseType == 'subscription' ? this.subFrequency : 0,
          addExtraTube: this.extraTube,
          attachableProdIds: this.attachableProdIds,
          qty: this.qty
        }
      ];

      return items;
    },
  },

  methods: {
    ...mapActions([
      'notifyWarn',
      'notifyError'
      ]),
    ...mapActions('modal', ['hideModal']),
    ...mapActions('cart', [
      'addToCart',
      'addMultipleItemsToCart'
      ]),
    ...mapActions('refillCart', ['addToRefillCart']),
    ...mapActions('subscriptions', [
      'initSubscriptions',
      'addSubAttachment'
    ]),
    ...mapActions('pdp', [
      'openPurchasePanelModal',
      'openPurchasePanelAttachModal',
      'openPurchasePanelSimpleModal',
      'openPdpXsell',
      'openKeepShoppingModal'
    ]),

    ...mapMutations('refillCart', [
      'setModifyingRefillProduct'
    ]),
    ...mapMutations('pdp', [
      'setAddPerfectPair',
      'clearAttachableProdIds'
    ]),

    mix_addProductToRefillCart(attachToSub, ctaSource, productId) {
      const product_id = productId || this.product.id;

      if (this.modifyingRefillProduct) {
        return;
      }

      //- when attaching to sub we need to call subscriptions.addSubAttachment
      this.setModifyingRefillProduct(product_id);

      let payload = {
        product_id,
        qty: this.qty,
        ctaSource: ctaSource,
        membershipAddon: true
      };

      if (attachToSub) {
        let subId = this.baseSubscription.subscription_id;
        payload.sub_id = subId;

        return this.addSubAttachment(payload).then(() => {
          this.hideModal();
          window.setTimeout(() => {
            window.location.assign(`/dashboard/subscriptions/edit-subscription/${subId}?subscriptionUpdated=true`);
          }, 600);
        }).catch(() => {
          this.hideModal();
          this.setModifyingRefillProduct(null);
        });
      } else { //- for regular refill cart as simple one-time product
        return this.addToRefillCart(payload).then(() => {
          this.hideModal();

          window.setTimeout(() => {
            window.location.assign('/dashboard/welcome?refillCartUpdated=true');
          }, 600);
        }).catch(() => {
          this.hideModal();
          this.setModifyingRefillProduct(null);
        });
      }
    },

    mix_addToBag(returnFocusElement, ctaSource) {
      //- this function depends on product inside pdp store module. when productId is passed in
      //- we will check if the pdp store has loaded this product and if not load it before proceeding

      if (this.addingToBag) {
        return;
      }

      if (this.productMaxQtyInCart(this.product.id)) {
        this.notifyWarn('Max Quantity already in cart. Please contact Customer Service for larger quantities.');
        return;
      }

      if (this.skipPurchasePanel) {
        return this.addMultipleItemsToCart({
          ctaSource: 'AddProduct',
          items: this.itemsToAdd
        }).then(() => {
          this.clearAttachableProdIds();
          if (this.cmsSettings.suppressPurchasePanelXsell) {
            return window.location = '/cart';
          }
          if (this.experiments['PDP On Page Purchase Box'] == 'B' || this.experiments['PDP On Page Purchase Box'] == 'C') {
            this.trackMREvent(`PDP On Page Purchase Box`, { version: this.experiments['PDP On Page Purchase Box'], items: this.itemsToAdd });
            return this.openPdpXsell();
          }
          this.openKeepShoppingModal();
        }).catch(err => {
          this.notifyError({ err });
        });
      }

      let modalPayload = {
        returnFocusElement,
        theme: 'full-screen'
      };

      if (this.product.renewable) {
        if (this.hasMembershipBenefits) {
          //- present full page purchase panel with all the fluff
          this.openPurchasePanelModal(modalPayload);
        } else {
          //- present smaller/simplified version of purchase panel
          modalPayload.theme = 'mobile-drawer';
          modalPayload.props = { panelType: 'simple' };
          this.openPurchasePanelModal(modalPayload);
        }
      } else {
        this.addingToBag = true;
        this.addToCart({
          cartType: 'active',
          ctaSource: `${ ctaSource } CTAs`,
          productId: this.product.id,
          qty: this.qty
        }).then(() => {
          if (this.cmsSettings.suppressPurchasePanelXsell) {
            return window.location = '/cart';
          }

          this.openPdpXsell();
        }).catch(() => {
          this.addingToBag = false;
        });
      }
    },
  },


  mounted() {
    //- need subscriptions when attaching items
    this.initSubscriptions();
  }
};
